interface IconProps {
  color?: string;
  className?: string;
}

export default function IgnitionIcon({
  color = "#8E929E",
  className = "",
}: IconProps) {
  return (
    <svg
      width="24"
      height="15"
      viewBox="0 0 24 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M23.34 12.9198H20.56V11.3198H19.87V12.0398L19.51 12.3998H16.89L16.53 12.0398V6.10984H19.87V7.14984H20.56V5.58984H23.34V12.9198ZM21.6 11.8698H22.29V6.62984H21.6V8.18984H18.82V7.14984H17.57V11.3498H18.82V10.2698H21.24L21.6 10.6298V11.8698Z"
        fill={color}
      />
      <path
        d="M12.11 15H5.91V13.96H3.83V11.32H3.14V12.92H0V5.59H3.13V7.15H3.82V4.55H5.98L7.06 3.47H8.02V2.81H6.78L6.42 2.45V0H13.75V2.81H12.19V3.47H13.11L14.74 5.07H15.86V13.08L15.5 13.44H13.66L12.1 15H12.11ZM6.95 13.96H11.68L13.24 12.4H14.83V6.12H14.32L12.69 4.52H11.15V1.77H12.71V1.04H7.47V1.77H9.07V4.51H7.5L6.42 5.59H4.87V8.19H2.09V6.63H1.05V11.87H2.09V10.63L2.45 10.27H4.87V12.91H6.95V13.95V13.96Z"
        fill={color}
      />
      <path
        d="M8.29999 9.75978H10.38L9.61999 11.6698L10.59 12.0498L11.91 8.71978H9.82999L10.56 6.82978C10.56 6.82978 9.74999 6.46978 9.69999 6.46978C9.66999 6.46978 9.64999 6.45978 9.61999 6.46978L8.29999 9.74978V9.75978Z"
        fill={color}
      />
    </svg>
  );
}
